// blob:/data: URLs are already local. Remote URLs need the dev proxy to dodge
// CORS in development; in production they rely on Azure's CORS config.
export const toFetchableUrl = (url) => {
  if (!url) return url;
  if (/^(blob|data):/i.test(url)) return url;
  return process.env.NODE_ENV === "development"
    ? `/api/image-proxy?url=${encodeURIComponent(url)}`
    : url;
};